import { bus } from "@App/domain/bus";
import { EventType } from "@App/domain/events";
import type { ID } from "@App/types";
import { differenceInCalendarDays, parseISO, startOfDay } from "date-fns";
import { useEffect } from "react";

type UseNearestSlotGoneAlertTrackingParams = {
  // whether the "nearest slot gone" alert is currently shown
  active: boolean;
  organizationId: number;
  garageId: ID;
  serviceId: ID;
  // slot advertised in the result list
  promisedSlotAt: string;
  // earliest slot actually available in the calendar now
  actualSlotAt: string;
};

/**
 * Publishes BOOKING_NEAREST_SLOT_GONE_SHOWN when the "nearest slot gone" alert
 * becomes visible. The caller decides when the alert is shown via the `active`
 * flag.
 */
export const useNearestSlotGoneAlertTracking = ({
  active,
  organizationId,
  garageId,
  serviceId,
  promisedSlotAt,
  actualSlotAt,
}: UseNearestSlotGoneAlertTrackingParams) => {
  useEffect(() => {
    if (!active) return;

    bus.publish({
      type: EventType.BOOKING_NEAREST_SLOT_GONE_SHOWN,
      organization_id: organizationId,
      garage_id: garageId,
      service_id: serviceId,
      promised_slot_at: promisedSlotAt,
      actual_slot_at: actualSlotAt,
      days_later: differenceInCalendarDays(
        startOfDay(parseISO(actualSlotAt)),
        startOfDay(parseISO(promisedSlotAt)),
      ),
    });
  }, [active, organizationId, garageId, serviceId, promisedSlotAt, actualSlotAt]);
};
